export default __webpack_public_path__ + "static/media/0.75010db2.png";